import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Fab } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'

export default function ToggleFullscreenMapControl() {
    const { mapIsFullscreen } = useEphemeralStore(
        useShallow((s) => {
            return {
                mapIsFullscreen: s.mapIsFullscreen,
            }
        })
    )
    return (
        <Fab
            style={{
                backgroundColor: ColoursObj.shades.shade4,
            }}
            size="medium"
            onClick={() => {
                useEphemeralStore.setState({
                    mapIsFullscreen: !mapIsFullscreen,
                })
            }}
        >
            <Icon
                name={mapIsFullscreen ? 'Minimise' : 'Enlarge'}
                width="28px"
                height="28px"
            />
        </Fab>
    )
}
